export type TableCellContentItem =
  | 'svg'
  | 'Limited'
  | 'Unlimited'
  | 'Bulk only'
  | 'Bulk and individual'
  | 'With Discovery Suite'
// Deprecated Lite plan, is hidden from the UI. Server-side validation in the Plan Change API will be done as a followup
export type DataTableItem = {
  header: string
  columns: {
    name: string
    props: string
  }[]
  data: {
    feature: {
      name: string
    }
    //'2020-lite'?: TableCellContentItem,
    '2020-plus'?: TableCellContentItem
    '2020-pro'?: TableCellContentItem
    '2020-enterprise'?: TableCellContentItem
  }[]
}
type DataTables = DataTableItem[]
export const dataTables: DataTables = [
  {
    header: 'Manage',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'WAV <-> AIFF converter',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'DDEX ingestion',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Custom Inboxes',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Custom fields',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Colored indicators',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'API Access',
        },
        '2020-enterprise': 'svg',
      },
    ],
  },
  {
    header: 'Discover',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Insights',
        },
        '2020-plus': 'Limited',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Reports',
        },
        '2020-plus': 'Limited',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Full Lyric Transcription',
        },
        '2020-pro': 'With Discovery Suite',
        '2020-enterprise': 'With Discovery Suite',
      },
    ],
  },
  {
    header: 'Share',
    columns: [
      {
        name: 'Feature',
        props: 'feature',
      },
      {
        name: 'Plus',
        props: '2020-plus',
      },
      {
        name: 'Pro',
        props: '2020-pro',
      },
      {
        name: 'Enterprise',
        props: '2020-enterprise',
      },
    ],
    data: [
      {
        feature: {
          name: 'Expiring share URLs',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Password protected playlists',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Can Share Channels',
        },
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
      {
        feature: {
          name: 'Alias metadata',
        },
        '2020-plus': 'Bulk only',
        '2020-pro': 'Bulk and individual',
        '2020-enterprise': 'Bulk and individual',
      },
      {
        feature: {
          name: 'Email creator',
        },
        '2020-plus': 'svg',
        '2020-pro': 'svg',
        '2020-enterprise': 'svg',
      },
    ],
  },
]

